
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Selge`,
'deleteKey': `⌦ Kustuta`,
'downKey': `↓ Alla`,
'endKey': `⤓ Lõpp`,
'enterKey': `Sisesta`,
'escapeKey': `⎋ Põgenemine`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Genereeri 
          <code>LITSENTSI 
          </code> faili 
        `,
'homeKey': `⤒ Avaleht`,
'keyCommand': `⌘ Käsk/Win`,
'keyControl': `^ Kontroll`,
'keyOption': `⌥ Valik/Alt`,
'keyShift': `⇧ Shift`,
'leftKey': `← Vasakule`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Õigus`,
's00065e45db8c0441': `Vt arendajatööriistade kohta lisateavet`,
's001dd78415a91fa0': `Kerimisriba soomus`,
's002fa7d1054ed082': `Piirikast`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kasahstani`,
's01b56d233c6c5cac': `Sektsioneerimine`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Uus pin...`,
's02ab1ea8e5100fc1': `Märgista valik "kahesuunalise ülekäiguga".`,
's0312976fe9da5951': `Nupp`,
's03608a32f05eded2': `Nips-suumimine`,
's036d35e03be98d22': `Matemaatika sügavus`,
's037b1dc850a89273': `Vaheldumisi all`,
's0396202b716732ec': `Märgista valik läbilöögiks`,
's03f49e598ffb11cc': `Poola`,
's0448f1059fa01720': `Salvestage, jagage või printige oma uuritav. Muutke teavet, näiteks pealkirja, keelt või litsentsi.`,
's0458872c43beadef': `Sisesta rida enne`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Sõnade vahekaugus`,
's05e9759cfd99c48f': `Õigustage`,
's063fa5a0a4903bf4': `Küljele, vasakult paremale`,
's064339c229374050': `Kodeerimine`,
's06634274f19b0572': `PIN-koodi valik`,
's06743b24499f0035': `Ankru keskus`,
's07808b0ca6da8fef': `Piiratud veebisait`,
's07970793b21351fd': `Ruby baaskonteiner`,
's079cf7850d9327f0': `Font`,
's07aa10850d9ddcc7': `Vorm`,
's07e6118e838b2e23': `Navigatsioon`,
's0816468df86e4036': `Avab seaded`,
's082869038c117fe5': `Portugali keel (Brasiilia)`,
's086e6c267ade2609': `Küllastumine`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Sisesta nimekiri (järjestamata)`,
's09c3f1d21de14ae1': `Märkige valik allajoonituna`,
's0a2d91c6720033e9': `Teksti vahekauguse kärpimine`,
's0a3ddcba94027d95': `Objekti sobivus`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Sisestage navigatsioon`,
's0a7db790db1fc45c': `Märgista valik vahemikuks`,
's0b1271f50a77dc73': `Sisukast`,
's0b24d08ea349b455': `Kõik, mida saab sisestada. Alguses on mitteinteraktiivsed elemendid, nagu nimekirjad või pildid, seejärel interaktiivsed elemendid, mida nimetatakse vidinateks. Uusi saate hankida, kui klõpsate otsinguribal.`,
's0bdca49248ba4820': `Otseteed`,
's0befccf152b6c0a9': `Orienteerumine metaandmetest`,
's0c11e479416c8421': `Tabeli pealkirja sisestamine`,
's0c27336067c59611': `Kerige polsterdus`,
's0c4593d81f147042': `Põhitasemel`,
's0c4b2e98d4ab7f5a': `Rakenduse käsud`,
's0c883713b83616a8': `Salvesta aktiivne dokument`,
's0ca5c0460199cba1': `Lühend`,
's0cf10c4f40588f8d': `Tabeli pildiallkiri`,
's0d86afa3c6a1e28b': `Paindlikkuse suund`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Teie uuritav dokument. Siia saate kirjutada teksti ja kopeerida/liita, redigeerida jne.`,
's0dc452999c129e15': `Võimaldage otseülekanne`,
's0de0febab8a4beaf': `Viga selle paketi lugemisel`,
's0e44968489e076a8': `Hiina`,
's0e4862e87c7d53ce': `Märkige valik tsitaadiks`,
's0e6ea8870dbddab2': `Dokumendi käsud`,
's0ee28503778e4c0c': `Viimane baastase`,
's0ef01c03299bbb83': `Kaunistus`,
's0f17f32919661cff': `Mongoolia`,
's0f350bc4e538e3ea': `Sõnad`,
's105a06836c40fcb4': `Määrake filtrid, värv ja valitud elementide segamine`,
's106b274b5af798e5': `Laused`,
's1082e1649793dca9': `Märgista valik määratletud terminina`,
's10f3845975a0351e': `Metaandmete muutmine`,
's1125d159f7e64df5': `Näita`,
's11326fd2590f4e5e': `Vaikimisi`,
's1155ec07a221e739': `Kerimisriba`,
's1173bf7a3e0b74c9': `Minimaalne (y)`,
's1177237a3e0e548c': `Minimaalne (x)`,
's1219d97b49650c05': `Nähtavus`,
's123bea44f38abccf': `Sisesta objekt`,
's1245e2cb9f20197e': `Joondage`,
's12946ec1b850962c': `Sisesta veerg pärast`,
's1351209ef74ee729': `Kõik veerud kokku`,
's13c60cb409e8cb6f': `Joondage keskus`,
's13ebd619c8a06a6d': `Ruudustiku automaatsed read`,
's13ef8ca26ca8861b': `Lõigatud element`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Lauapea`,
's156647179b21d351': `Tabeli keha sisestamine`,
's158b6ec6b1fffcb2': `Paus pärast`,
's15d0c0657c1ee08c': `API võti`,
's1626a7e10a9f9dcc': `Määrab valiku kirjatüübi perekonna`,
's1637c7d1a30629e2': `Piirikast`,
's1641ab440bf4daa4': `Selle vidinapaketi uuendamine`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Edasijõudnud: Näita paketihalduris pakette versioonidega nagu 0.x.x`,
's16b9446e3a70e1f4': `Atribuudid`,
's16f205466761e583': `Optiline kirjasuurus puudub`,
's16f2f1c2c516d307': `Avage dokument`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Litsents`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `Eemaldage väli`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Loo pakett`,
's18d5c44aae3dc82a': `Online redigeerimisel`,
's1988d71ef8060edf': `Tabeli rea sisestamine`,
's19abee1277c9bca2': `Samoa`,
's19daf2f26c19543d': `Ümbrised`,
's1a1acc902e6668e0': `Näita täiustatud teksti vormindamist`,
's1a5230a71d9285c1': `Capture`,
's1aa1cb63ad44bc6f': `Veergude vahe`,
's1af8b67d1c85c811': `Vahepealne ruum`,
's1b4a36fce2456660': `Kirjatüüpkond`,
's1c246045629b0016': `Märgista valik kustutamiseks`,
's1c3fc313a9184670': `Avalik link`,
's1c65f5004a07dcfa': `Šoti gaeli keel`,
's1c690963f1e2df00': `Platvormipõhine välimus`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Soovite lühikest giidiga ekskursiooni?`,
's1d19244f549ec535': `Haridus`,
's1d5c7b28e8b50d6d': `Assotsieerunud kraad.`,
's1db591f5a54dbfd3': `Sisukast`,
's1dbb9f50e16c92a3': `Piiri raadius`,
's1dfb744260fb3a01': `Kahesuunaline isolatsioon`,
's1e9c2c654732cc5f': `Valgevene`,
's1eaccbf2d6af8ab5': `Teave`,
's1efbfc3937d565bd': `Taustaks`,
's1f2b49c1bca2035d': `Katalaani`,
's1f74bdf32b51a5fc': `Taustapilt`,
's1f7698c061c208c9': `Avatud`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsika`,
's21d61916eb8d137d': `Lauakere`,
's21d723a1dbcd89c8': `Javanese`,
's21f8a2eaf5a70749': `Sisestage silt`,
's2206c42e5b835e6e': `Märgista valik lühendina`,
's22a2348c46a912a0': `Sisestage lõik`,
's233ae776268cd44b': `Äri`,
's236ed7ba747099b0': `Kirjatüübi kaal`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Tekst`,
's24949d7adbb5a098': `Tööriistakast`,
's252a52330d32b900': `Metaandmed`,
's2540844a4bc4d9ba': `Nõuavad atribuute?`,
's255857544a9d5ec0': `Reset`,
's255c77900f2b5e0f': `Värviskeem`,
's256ab831a48c941c': `Eemaldab kõik teksti vormindused valikust`,
's2591806d7b222591': `Muudatuste lähtestamine`,
's25e1a07e454c2c11': `Võrk`,
's262abbaf1d05f009': `Pehme valgus`,
's266935f2447fcd98': `Üle vasaku`,
's268ecd1cef45a9a8': `Oled sa kindel?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Valgustage`,
's27076e66c5d483ba': `Vertikaalne joondamine`,
's2712dc5641a33226': `Paketi registrikontod on mõeldud arendajatele ja võimaldavad konfigureerida ühte või
          mitut registrit.`,
's27cc88818cc46ff6': `Stabiilne`,
's281d957112b10f12': `HTML-dokumendi otsene muutmine`,
's28b6246ce616a548': `Tabeli veerurühma lisamine`,
's29a1c26521879b9f': `Vähendada suurusjärku`,
's29acfd2778e8c377': `Varjata täiustatud teksti vormindamine`,
's29b24c06315e9343': `Sisendi sisestamine`,
's29eb103449472e3b': `Sisestage pealkiri (tase 3)`,
's29ee7434494a0dfe': `Sisestage pealkiri (tase 2)`,
's29f21c34494d614d': `Sisestage pealkiri (tase 1)`,
's29fbfc3449557f72': `Lisage pealkiri (tase 6)`,
's29ff743449588131': `Sisestage pealkiri (tase 5)`,
's2a031834495bcdb4': `Sisestage pealkiri (tase 4)`,
's2a75c946ef4dcab7': `Mitmesugused`,
's2b2ae20d26f78ac2': `Plokk`,
's2b8f50c64be440f7': str`Valige 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Tellige`,
's2bad2d24def4aa0b': `Rida ümberlülitus (CJK lang.)`,
's2ceb11be2290bb1b': `Tühista`,
's2ced8e8fafb499f6': `Kustuta element`,
's2d986d31f8d67357': `Sisestage väljakomplekt`,
's2d995a37cf5e4995': `Sisestage NoScript`,
's2de969afacdaa7a6': `Kuju`,
's2df075aface0dab8': `Jaga`,
's2e192b19ed15fcf6': `Lehekülg`,
's2e39b99cf23606fa': `Määrake valitud elementide paigutus`,
's2e4818861000b13f': `Paigutus`,
's2e66bf8b833858f3': `Uigurid`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Ülevool (y)`,
's2edd6688a65e21f0': `Ülevool (x)`,
's2f0bcdffc92a786b': `Ujuma paremale`,
's2f2044f2431a32d5': `Pealkiri`,
's2f4d4bfbc466d91f': `Albaania`,
's2f8da2cb5f236588': `Teie paketi nimi. Peab olema piiritletud, nt \`@org/pkg\`. `,
's30cce87854901922': `Koolieelne lasteaed`,
's3124653c272f054c': `Veeru reegli värv`,
's314a4f7685c8e824': `Alati`,
's31c06e226322f065': `Vältida orbusid`,
's323dcde72b850272': `Avalik juurdepääs`,
's32911e52ee8ac745': `Sisestage pesa`,
's337a1e9022a8d19f': `Tabel`,
's33c1450d2822bb0f': `Sisestage joonise pealkiri`,
's33c18d5a4cbffa2a': `Iiri`,
's33f85f24c0f5f008': `Salvesta`,
's342b0cabfa672822': `Aidake kasutajal leida oma vidinat`,
's3437e0d9899e7ae1': `Saatke telemeetriaandmeid WebWriteri kasutamise kohta.`,
's344ea8f4939cdc98': `Värv`,
's34dcda3b0f9d5a98': `Vaheta url`,
's34f724979a124c50': `Määrab valitud teksti taustavärvi`,
's355b21b89ce5d9c5': `Üksikasjad`,
's35ae5f4e0fa2777b': `Kohandatud joondamine`,
's35aeaff1425bca9e': `WebWriter ei toeta tüüpi meediat `,
's35c3125c7750681e': `Blockquote`,
's3643189d1abbb7f4': `Kood`,
's3649bacefe731bf6': `Tööriistakasti lülitamine`,
's365280e16a8ea32d': `Valiku kopeerimine`,
's366991b9c9287765': `Õigus`,
's36a194e38d653a26': `Andmete märkimine`,
's36b3cefdcb897f15': `Perspektiiv`,
's372fae706048ce41': `Even-odd`,
's377e24af9628c37e': `Tellitud nimekiri`,
's37a8c35f6581da5f': `Ei ole ankurdatud`,
's37fa3b9cd51c2dfd': `Määrab valiku kirjasuuruse`,
's380d17664bb69531': `Sisesta veerg enne`,
's3815184eb09f0dcf': `Kursor`,
's382a2aa3984474dd': `Loo`,
's38980f98cb07ceb8': `Salvesta aktiivne dokument koopiana`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Ruby positsioon`,
's3a5ca02f282d247e': `Jaga...`,
's3ae67088bbefba98': `Pakendid`,
's3b0ab4b52326316f': `Valgus`,
's3b3ea038c5d3bb06': `Osakond`,
's3bdad99768e11911': `Uuritav`,
's3cb47df8290fa94c': `Lisage valikuvõimalus`,
's3cf89cb47fdde7e9': `Link`,
's3d09398e555ee5f9': `Täiustatud valikud`,
's3d249bb480032121': `Loetelu`,
's3d3efd1e19bdcfb4': `Kuupäev/aeg märkus`,
's3d6a732c792ccb9e': `Ruby märkus`,
's3d93f9ea0c5a13fa': `Pilt`,
's3d9548e211b958ce': `Ületused vahele jätta`,
's3e092e9d1ee2c5bb': `Klipp`,
's3e78ddc9a48a608d': `Pretty`,
's3eb6d1e6e79ed7c4': `Dokumente ei leitud`,
's3eca5a034978754b': `Kustuta valik`,
's3f06e9abb6ebcb79': `Tegelased`,
's3f1e7a3f2b283d3b': `Marginaal`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Sisesta artikkel`,
's3fd83566dd643d10': `Lisage legend`,
's3fe72792941c18f9': `Teksti põhi`,
's3ffcdc5db5e7d0c5': `Tagasi`,
's40e3826b7f74a3b5': `Pan (paremal)`,
's40f07d7859284a44': `Domineeriv baastase`,
's4101ada154a1b958': `Keskmine`,
's410c465a5993f82d': `Rida katkestuse võimalus`,
's41322d19c928c603': `IKT`,
's417b90913e05bc17': `Eelvaade`,
's418f2020fe996832': `Kinnitage muudatused`,
's41c724f0698148e9': `Märgi valik klaviatuurikombinatsiooniks`,
's41f65a763f8e44ab': `Tabeli päise grupp`,
's42721130228841b0': `Löögikast`,
's429bd646f1cf8bc6': `Grammatika LLM-i kontod võimaldavad teil kasutada grammatika LLM-i API-d teksti grammatika parandamiseks.`,
's429dd933ba95549b': `Sisestage aadress`,
's42e470ef1d707a28': `Automaatne mängimine`,
's42ffdab1291fb3de': `Lisa rida pärast`,
's430831017f3f0499': `Kalduvus (y)`,
's430bd5017f42511c': `Kalduvus (x)`,
's433ba70286202ceb': `Murda kõik`,
's441b20a8a50e36b4': `Makedoonia`,
's445b8acb9206db6e': `Visake ja tühistage`,
's446a924922651ea0': `Teksti rõhutamine`,
's44cdba92713de38e': `Ruudustikuala`,
's45518abd911471d0': `Horvaatia`,
's456a8d744313852a': `Ruum ümberringi`,
's4634541f5056a546': `Abhaasia`,
's46d4abe6255cb9e1': `Määrake otsetee ümber`,
's4730c232e7209c40': `Trimmige mõlemad`,
's474f0eec369d02a4': `Näidise väljund`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Märgista valik kuupäeva/aja märkusena`,
's47ebf3a8fb3b10c1': `Orienteerumine`,
's4802bb8eb52fbdeb': `Portaal`,
's4802e47fe2e95134': `Valik`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Teksti vari`,
's4993444bfd3f3e5e': `Kokkupõrge`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Mask`,
's49dd67aed00029ef': `Matemaatika`,
's49e763aed00877a8': `Main`,
's4a894f57eba1cf1e': `Klaviatuuri otsetee`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Karm valgus`,
's4b2c143acf931122': `Rea kõrgus`,
's4b58c01e2578f5e4': `Legend`,
's4bbff4e008690da1': `Vältida lehekülge`,
's4c1535f316305a2a': `Kontrollida valikut`,
's4c402ff5355fd310': `Kahesuunaline ületamine`,
's4caed5b7a7e5d89b': `Inglise keeles`,
's4cb38675a21b2c98': `Toetamata omaduse tüüp '\${desc.type}' (töötlemine JSON-ina)`,
's4cc8391f172c0cdf': `Lõpeta ekskursioon`,
's4d528b416ac8dee2': `Sisestage pealkirjarühm`,
's4d546f6c87128d5b': `Esmalt kosmos`,
's4dcb9315f6527f9c': `Käivita uuesti laadimisel`,
's4e191bdb4700a6e9': `Ümberlülitus (x)`,
's4e1c7fdb470386ac': `Ümberlülitus (y)`,
's4e2562fe3990e621': `Ühendamise viga`,
's4e361bf8eef3759a': `Sõnapaus`,
's4ea0f21fc2a338a1': `Liigu ülespoole`,
's4eace13b3ed74187': `Külgkommentaar`,
's4efee5b48a4593cb': `Loop`,
's4f26e7cb7c0a8318': `Vektorjoonistus`,
's4fd2e638aabb0bb3': `WebWriter toetab paljude erinevate allikate manustamist. Lihtsalt kleepige link
          sisule:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Tai`,
's5015a8fb33b98872': `Õhuke`,
's50489ffb1bde152e': `Sisestamine`,
's5068560b8d39663d': `Klõpsatav kaart`,
's517acbf1f96324f9': `Kaal`,
's523eb9043213ff0d': `Kursiivne`,
's52777d434baeed9b': `Sisestage edusammude indikaator`,
's52af5d7ac34c2163': `Tabeli rida`,
's52e0bdc3ee304436': `Sisestage arvesti`,
's531056f039febd39': `Sisestage valik`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Avage või sulgege tööriistakast (ainult kitsastel ekraanidel, muidu on tööriistakast alati küljel nähtav).`,
's5432ad3c84273229': `Joonis`,
's543906d1db8b2283': `Muuda `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodža`,
's54897f2764b0e4d0': `Paigaldage see vidinapakett`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Märkige valik kui väga oluline`,
's55905c735052d295': `Temaatiline paus`,
's5590dbf7e425789d': `Silt`,
's5623aa2f83b05c76': `Tiibeti`,
's564d1648b1ceee9f': `Kuni tänaseni`,
's565cd5ffb0158c46': `Vältida piirkonda`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Mine tagasi`,
's5787c6d5b3b5541a': `Klambrite tee`,
's579c69f419b6caef': `Smooth`,
's587ac858dd80f6fa': `Alaindeks`,
's58bec0ecd4f3ccd4': `Range`,
's59404f5593c32fdc': `Kirjatüübi kerning`,
's5941292bb77281ab': `Norra keel Bokmål`,
's599dcd2472c75c19': `Paragrahv`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Märgista valik andmemärkusega`,
's5a356677b61a6b7e': `Moldova`,
's5b474b5c0ac0c7c4': `Tabeli veergude rühm`,
's5b517ac216f9ee62': `Sideways`,
's5b8cc9bb61ddce15': `Lisage lõik`,
's5bba2ac2e53bd1fd': `Kirgiisi`,
's5be80ad6b8301710': `Inline start`,
's5c1ecf88259b79f9': `Esitlus`,
's5c2a1a52c0389c30': `Tehnika`,
's5c63af7695445fcf': `Teksti stiil`,
's5d18ca4c3111be6f': `Tabeli päise sisestamine`,
's5d87c1e588f48d90': `Praktika`,
's5d929ff1619ac0c9': `Otsi`,
's5da52af9b083c29a': `Mudel`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Logi sisse`,
's5e2cba97c0d971bd': `Pakettide ümberlaadimine`,
's5e53415a6d5719ad': `Sotsiaalteadused`,
's5e6a7a0c30d2a270': `Ületuste vahelejätmine (automaatne)`,
's5e9e8e4d21bafedc': `Toiduainete tootmine`,
's5ed03bb1f3a15949': `Pilt`,
's5f43af3669b1e098': `Allikas`,
's5feaf7fd7ee567c8': `Break sõna`,
's600fd23c9ce971e8': `Prindi aktiivne dokument`,
's602bbd28dae2c60f': `Iseseisev start`,
's60ff598dfcf2c773': `Õiguse all`,
's61053f0e3ebbd272': `tavaline`,
's613c6ff83883c04f': `Tabelisammas`,
's6196153c4b0c1ea0': `Paigaldage`,
's61c017f6d5c303af': `Friisi`,
's61ded17ca3f48c82': `Allapoole nihutamine`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Valiku kopeerimine`,
's624e31cd4f1b89d4': `Sujuv kerimine`,
's626daf42b1ab7df7': `Joondage vasakule`,
's6280bf993915c57a': `Rullimise varu`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Kirjeldus`,
's63dfc5b1c1c27849': `Jidiš`,
's63e03c70f67ebf9c': `Kontekst`,
's63e71d20d1eaca93': `Saksa`,
's640bc7710d0143ce': `Viimase tegemata muudatuse taastamine aktiivses dokumendis`,
's64dc1fc7e3db45c9': `Uue dokumendi loomine`,
's65ac276544ba33cd': `SVG fail`,
's66765c420ee578e4': `Ruum ühtlaselt`,
's669b18c6d2d9c95b': `Puudub`,
's6747dbf4ad6063ba': `Self end`,
's6787497df07fa97e': `Võib kerida üle peatuste`,
's67c2b60a506a09e4': `Teise taseme hariduse omandamine.`,
's680bd4d926cd5a84': `Säilitada 3D`,
's6827930ef1aeaf99': `Baasi URL`,
's684a16f3c711394d': `Üle paremale`,
's687e27f036a71b32': `Isoleerida`,
's68b87d7b61052dc3': `Tabelirida`,
's68e0e3a2bab7ce3e': `Vältida`,
's690da6b432987c6f': `Praeguse dokumendi muudatuste varundamine automaatselt. Muudatused taastatakse, kui WebWriter laaditakse uuesti.`,
's69311c4e25074fb3': `Keskkool`,
's697400b541fbc3cd': `Veebilehel`,
's6988ab5d47593a26': `Teil on WebWriteri uusim versioon.`,
's69a49786a8009f43': `Leia paketid...`,
's69b12144dbb6544d': `Laotimaa`,
's69d88ef4b2618980': `Kaane`,
's69fbbdb8ad2a084a': `Tumeneb`,
's6a31eff1ec4f71ad': `Peida tagakülg (3D)`,
's6ac62e1c8c66f3bb': `Kompaktne superscr.`,
's6b585ba37cdb8260': `Inherit`,
's6b61f8abf89586be': `Heebrea`,
's6bd7a02fdf93e653': `Viia sisu vastavusse`,
's6cfc66b824ea05ba': `Teravad servad`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnami`,
's6d8b3b8047ed378d': `Segamisrežiimi segamine`,
's6d8c02aee480af7a': `Menüü`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Sisestage stiil`,
's6e288a119281f4c2': `Teksti esitamine`,
's6e4c20c6debcd5ca': `Kohandatud õigustada`,
's6f84199e62584905': `Eelvormitud tekst`,
's6fb3053e7244d326': `Muud valdkonnad`,
's70178e04a3b691b6': `Avatud seaded`,
's7031ca562378bde6': `Geomeetriline täpsus`,
's7060970b5ed20a58': `Interaktiivsus`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Näita ebastabiilseid pakette`,
's71dec51005acc1e4': `Rida tihe`,
's72f2a02e2a5a4ee3': `Meedia`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `See seade`,
's736904f276fbd441': `Loodusteadused`,
's739544d0c858c633': str`Või tilkuda 
          ${0} siia 
        `,
's73cb20c838e761e1': `Lõike valik`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pikslites`,
's743f778233e42a3f': `Lisage kõrvale`,
's744d993d03f29851': `Ekraan`,
's748c0074eff45884': `Manipuleerimine`,
's74aa0039a87141e2': `Ellipsis`,
's74b9781bacfcc87c': `Pandžabi`,
's74cd20a7aece9b91': `Täida kast`,
's75109f5307578a61': `Tere tulemast WebWriterisse`,
's75a27f43413e02c5': `Prantsuse`,
's75d83fc3f0cfab40': `Pealkiri`,
's762e5704cc84089d': `Määrake valitud elementide muud stiilivalikud`,
's77318393dfdb0775': `Eemalda rida`,
's77e594ddcc10c774': `Lubada ärilist kasutamist?`,
's782eac2b3e80323d': `Märgi valik rõhutatuks`,
's782f286a79cca35d': `Suhteline`,
's78673a3539cb1915': `Ülemine vasakpoolne`,
's78789724e789221c': `Suurus`,
's789ff24c8f03f1a4': `Kirjade vahekaugus`,
's7995733bf97c01cc': `Serbia-Horvaatia`,
's7a99528e7b64635a': `Oktsitaania`,
's7aaf0c06e69600f1': `Viga koos `,
's7ae49e142487766c': `Ühenduse juurdepääs`,
's7af555180b30a947': `Avage arendaja tööriistad`,
's7b4ba250601b8667': `Sisestage mall`,
's7b560d8693ed8f42': `Püstine`,
's7b9994904c4f5b54': `Tadžikistani`,
's7bdf0fd5b014d36c': `Tugev tähtsus`,
's7beb1e77e82363eb': `Viimase muudatuse tühistamine aktiivses dokumendis`,
's7c61118554a0ec36': `Maksimaalne (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Ettevõte`,
's7cfe12cd14df9950': `Kirjutage välja`,
's7d27db3c9639c6dd': `Alternatiiv`,
's7d8103f6f06f83d6': `Pehmendus`,
's7d864465dddbb50d': `Lubab suuruse muutmist`,
's7de0e28d6c309a4e': `Luba puutetegevused`,
's7dea785045c3cc74': `Vajutage uut klahvikombinatsiooni...`,
's7e0b179d4d1414eb': `Sisestage link`,
's7e6570f2f1ae320f': `Kirjatüüpide sünteesimine`,
's7ecb1f29332293e5': `Kohandamise lähtejoon`,
's7ed13ccddb1bf3c3': `Overlay`,
's7edbe0b213199995': `Bakalaureuseõpe`,
's7ede1c55e35ce9d6': `Simulatsioon`,
's7f09197a4814079b': `Määrake valitud elementide interaktiivsuse valikud`,
's7f326a142e856656': `Stiil`,
's7fcb35d23be1e643': `Väljakute komplekt`,
's80570196a9ce6d11': `Telemeetria lubamine`,
's806f84eb0ace116e': `Vaadake, mida olete valinud, ja muutke seda. Kopeerige, lõigake, kleepige, kinnitage või tehke paigutusmuudatusi. Pakub erinevaid võimalusi sõltuvalt teie valikust, nt teksti vormindamine.`,
's80a42b81c52d4d8f': `Kärje värvus`,
's80b71fc6f43c5ce1': `Lahtine`,
's812cbda653daaeba': `See funktsioon ei ole veel rakendatud`,
's814d528c8af55807': `Määratlusloendi kirje`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Jätka`,
's8247d32213e35f24': `Sisestage peamine`,
's82665b2ffabc9c0a': `Veebileht`,
's828b1ecea8715884': `Pan (vasakule)`,
's833bd0422a7ef95d': `Tabeli suurus`,
's83420ad7b6a14db5': `Toggle Dev tööriistad`,
's83c15613b6f6f3c8': `Ainult internetis`,
's83cd32b685ccc9b7': `Kontrollid`,
's83f26d02dd7aa681': `Nähtav`,
's840fa49e8989c028': `Asend/kuju`,
's844a76d1843ceb3c': `Lähtestada vaikimisi`,
's84e4e8ae645b82ac': `Paremal üleval (y)`,
's84e9c7f8785ca60b': `Sisestage vorm`,
's8517ae4da104b004': `Tabeli veergude rühm`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Litsents Creative Commons OERina?`,
's85f9aa6d3ea0e421': `Tabeli jalusgrupp`,
's864b0e6270e97246': `Märkige valik külgmärkusena`,
's8670e5ad3bf0dcf8': `Salvesta kui`,
's8688d74dd3716d6e': `Klaviatuurikombinatsioonid käskude jaoks`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Kujundusvaru`,
's87cefc710b3567fb': `Sisaldab`,
's88676f992b2965db': `Stretch raku sisu`,
's886897f2fd4edb99': `Peidetud`,
's886c5db2a5579873': `Kontseptsioon`,
's888c71e8fcb916d3': `Automaatne salvestamine`,
's88a62d29529948fb': `Tabeli sisestamine`,
's89950d86c8004d4b': `Jäta kattuvused vahele`,
's89bca7498f20e041': `Taustaklipp`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Paus enne`,
's8a4ff2bd9c13498c': `Rekord`,
's8a6585c48ea104e9': `Peida tühjad lahtrid`,
's8a9eb438abac7c6a': `Märgised`,
's8b0432eecbd8b034': `Ajakohastamine`,
's8b7580c35e2aef87': `Ülemine vasakpoolne (y)`,
's8bc4affa761aa8a2': `Pildi sisestamine`,
's8c7f51cb067644c7': `Andmete loetelu`,
's8d342ecaa9e75b9b': `Suhted`,
's8d797888455f4147': `Vaheajad`,
's8d83386457e91813': `Muudatuste tühistamine/taastamine või eelvaade õppija vaatenurgast.`,
's8d8643013a7754d1': `Teksti joondamine`,
's8df30fe2a50d3479': `Lisage reavahetuse võimalus`,
's8e715248c3a78446': `Lõigake valik`,
's8f29e48d6b9a1aa8': `Tabeli päise rea sisestamine`,
's8f4be9f086eb530f': `Undo`,
's8f533296a536965e': `Salvesta kui...`,
's8fad58c831ecf017': `Ruby teksti konteiner`,
's8ffe7abcbed8eb43': `Vertikaalne, vasakult paremale`,
's90105521fcc40453': `WebWriter Cloudi kontod võimaldavad teil dokumente võrgus salvestada ja neid
          õpilastega jagada. Lisage konto siia ja see on saadaval dokumentide salvestamise,
          laadimise, jagamise ja avamise kohana.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Fontide palett`,
's90f7c1cf501ea0a7': `Värviline väljavedu`,
's91093e0b087911ba': `Rõhuasetused`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Sisesta embed`,
's9219acd5bef6269e': `All vasakule`,
's92548405912d46bf': `Kerige nihkega joondamine (y)`,
's9258280591309342': `Kerige nupuvajutusega joondamine (x)`,
's927d796559f49439': `Taust Päritolu`,
's92b177e579ef7b97': `Rõhk`,
's92f846b9be2e8e8d': `Märgista valik kursiiviks`,
's93566b84230af4f5': `Sisestage pilt`,
's936aa0b239679585': `Sisestage temaatiline paus (tavaliselt kuvatakse horisontaalse joonena).`,
's9370dc6afa716b57': `Piiril`,
's93f083e654a45715': `Bretooni`,
's94653c76b2d86a04': `Määratletud mõiste`,
's9485af2e7cd9418f': `Põhikool`,
's94d2eee44b292567': `Täiustatud valikute ümberlülitamine`,
's94d61907ee22a8c1': `Korea`,
's94eb1effbbb6498b': `Ülevool`,
's951aa3a6439f1271': `Loetelu marker`,
's9565553d163fc92a': `Skript`,
's957787fc6b7ea5c0': `Pan (üles)`,
's95c161f68e5180a5': `Kontrollida valikut`,
's95d56e58f816d211': `Hollandi`,
's95d8e41a64635c7c': `Valge ruum`,
's95de7e1eff6c053e': `Horisontaalne, ülevalt alla`,
's960d3a90ac199368': `Rhaeto-Rumeenia`,
's96532132a29dd542': `Sisestage heli`,
's96a045dcade75ad0': `Veerg tihe`,
's9781a5bb3fcb26a3': `Valige kõigepealt ettevõte`,
's978522fbc9577a7e': `Somaalia`,
's97881699a2b21d5b': `Ridade vahe`,
's97aa76056a81bd36': `Mõõdikud`,
's986facb3ecc9602c': `Külgmine, paremalt vasakule`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Väline fail`,
's98977a87d1b93941': `Teabe, stiilide ja skriptide lähtestamine`,
's990d0e0fa2ab00b5': `Galicia`,
's99229574e5692f19': `Gröönimaa`,
's99a990f3841ad283': `Failid `,
's99b38e000175cc84': `Ülestriigitud`,
's99f110d27e30b289': `Pealkiri`,
's9ab10fbf4c7a7322': `Rõhu allapoole jääv positsioon`,
's9abadcc828884d7b': `Tekstiala`,
's9b7cd8860c8fc922': str`
          ${0}
          kirjutatakse üle. Kas olete kindel? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Taustavärv`,
's9c8df9626d152d5a': `Määratluse loetelu termin`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Tabeli veerg`,
's9cf68f87b8e6122f': `Aserbaidžaan`,
's9d167ef77aed79b6': `Kiht`,
's9d2d00982edafabb': `Türgi`,
's9d430adc5be110e9': `Rida tagurpidi`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Kustutamine`,
's9df571714a1efb44': `Saadaval on selle uuritava versiooni automaatne salvestus. Laadige see?`,
's9e28faa598332e2b': `Lisa video`,
's9e3dbb678150edd4': `Kirjatüüpide perekonna määramine`,
's9e40e59654c8ad67': `Veerg`,
's9e85800d3700e31c': `Rada`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Kirjatüübi variant`,
's9f1ecdb3061d9cbc': `Säilitada ruumid`,
's9faf26107ed49fb9': `Tabeli lahtri sisestamine`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Üleminek`,
's9ff3121d30f88d52': `Tavaline`,
's9ffe1bbe64712bf1': `Kangas`,
'sa00df4e39c72d3b4': str`
          ${0} ei ole toetatud 
        `,
'sa013e119fec906fb': `Rida`,
'sa01e7bf33563ef72': `Taustatähis Kinnitus`,
'sa126cf8c627cec1e': `Pildi renderdamine`,
'sa13f72278add7513': `Õiguse all`,
'sa1647e3b36ec08d7': `Kombineerida püsti`,
'sa172190ea21f9b1c': `Juurdepääs seadetele, avage uuritav või looge uus.`,
'sa1c6c459b9b5115c': `Absoluutne`,
'sa2cba871f6cdd99f': `Assami`,
'sa2eff4dad1c119f1': `Ruudustiku mall`,
'sa30c12014e955946': `Vene`,
'sa30f1981fd1cd441': `Kirjasuurus`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Sisestage joonealune osa`,
'sa37fee6a52d18063': `Kustuta dokument`,
'sa39c7ac1d37f3bce': `Märgista valik kui "kahesuunaline eraldus".`,
'sa3b4c01623211544': `Jõudu`,
'sa40fd43756fa8913': `Pärsia`,
'sa417644bef21a9aa': `Nimetu teema`,
'sa43800e28be1bdbc': `Dekoratsioonivärv`,
'sa477cb1825dceb3b': `Sudaani`,
'sa492a51a707930fa': `Plokktsitaadi sisestamine`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Allpool olev pealkiri`,
'sa50d3c35533f1d99': `Kõik väljad`,
'sa53c5cb03a8fda50': `Kinnitage valik paletile lõikena paletile`,
'sa557ae6bee9148a6': `Progress`,
'sa589e1df65dde0ec': `Määrake valitud elementide suurus, polsterdus ja marginaalid.`,
'sa5c371b4bb75e590': `Vasakpoolne`,
'sa5c80e623459ffe4': `Sisestage päis`,
'sa5df1bcdba46c3fb': `Joonis Pealkiri`,
'sa602e3fd3f2d98fd': `Animatsioon`,
'sa644d580d8a11e60': `Rubiini joondamine`,
'sa645d315510dc09e': `Vali tee kettalt`,
'sa65d4ad99f1d8c06': `Teksti tausta määramine`,
'sa6607436f60ccc1a': `Eesti`,
'sa6f8d27bca557059': `Liigutage meta/link/stiilelemendid üles/alla sellesse elementi`,
'sa757645ad842da97': `Säilitada pausid`,
'sa75b95980cd80e78': `Toimetaja`,
'sa7698b3d20a6d1ec': `Kerige`,
'sa778acc33947c7b8': `Lõpeta tuur`,
'sa78a67272a4a6f95': `Matemaatika valem`,
'sa79167651dce1e80': `Vahelduv tekst`,
'sa7af797a46c7d09a': `Tabeli alumine osa`,
'sa7dbe35b758c138d': `Sisestage lõuend`,
'sa7dc6b8ef3f595dc': `Sisesta allikas`,
'sa8279f8211b3950d': `Säilitada pausid ja ruumid`,
'sa8b55cab62e439b5': `Eemaldage veerg`,
'sa8bbe0197d31b423': `Lühikirjeldus`,
'sa9ff3b762365abe6': `Transformatsiooni alguspunkt (z)`,
'saa02e3762368ff35': `Transformatsiooni alguspunkt (y)`,
'saa065776236bfa28': `Transformeeri alguspunkt (x)`,
'saa33768e03c45fc8': `Faili suurus`,
'saaad98061a20ac39': `Sisesta matemaatiline valem`,
'saab875d8cfcfe712': `Teema`,
'saad4380b9cc6cefd': `Vaheldumisi üle`,
'saaec15c97a9e4245': `Veerg tagurpidi`,
'sab0c57df694a0a09': `Trimmi algus`,
'sab4d9283896d9422': `Snap resolutsioon pikslid`,
'sab55faae8e165407': `Padding&lt;br&gt; nagu lõhe`,
'sab5e7d2a069a2951': `Kutsetunnistus.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Joondage paremale`,
'sac895c732f350ac5': `Tume`,
'saced41ddda8b2354': `Paindlik alus`,
'sad190f86451081c0': `Nepali`,
'sad6be321164d08c8': `Kompaktne matemaatika`,
'sadd352cc7f6f2307': `Kõrvale`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Rootsi`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maoori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Lisage kirjelduste loetelu (sõnastik, terminiloend).`,
'saf3da7c95cb17260': `Märgista valik ülakirjana`,
'saf440a0a592f2835': `Ajakohastamine`,
'saf9e5134ba1a7d30': `Scroll snap`,
'safc6f203342d09e2': `Aktiivse dokumendi eelvaate lülitamine`,
'sb0a7e3adf4a125ee': `Paremal üleval`,
'sb0a974028c99ca6d': `Kas kohandused on lubatud?`,
'sb0d4f0f7993cf085': `Kirjasuuruse määramine`,
'sb0f3327210fe18fc': `Veerud`,
'sb0f93c1c60c0249a': `Rubiinne alus`,
'sb1494c08c8c720d1': `Teksti värvi määramine`,
'sb19611adbc88f711': `Edasijõudnud: Näita lähtekoodi redigeerimise käske, nt dokumendi HTML-i näitamiseks või kohandatud stiilide ja skriptide lisamiseks.`,
'sb206d700d26b14ff': `Rõhutage`,
'sb233557012dcb328': `Liigu alla`,
'sb26035b596566abf': `Nimetu`,
'sb2cda80610c8d6ea': `Ruumi kõik`,
'sb2dc787b0983ebc6': `Leedu`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Keskus`,
'sb3ba3276ae93627c': `Eelvormitud tekstiploki sisestamine`,
'sb430f5b4824de0d3': `Valige paigutus`,
'sb43db07b24da018a': `Amharic`,
'sb45f9fb4dba6e71a': `Unset`,
'sb4e003a459464d85': `Kurdi`,
'sb4f0310e6787d098': `Usbeki`,
'sb4f1dffbb6be6302': `Selge`,
'sb51270e19988f9bd': `Piirkond`,
'sb59d621e3c93cc27': `Jagatud lahtrite piirid`,
'sb5e9e1776242b028': `Interaktsioonid`,
'sb60bc1250aad44c1': `Spaan`,
'sb60dd9d23d31ee66': `Doktorikraad`,
'sb6103872073d369e': `Sisesta üksikasjad`,
'sb616811735bfbafd': `Tabeli lahter`,
'sb628960829e223bb': `Jäta kõik kattumised vahele`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Rakendage ja importige`,
'sb66e2181a7b5738a': `Telemeetria lubamisega lubate andmete kogumist ja säilitamist vastavalt meie`,
'sb67e0e7c0869f982': `Erinevus`,
'sb68e83cda6c85af8': `Tabeli päis`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Dekoratsiooni paksus`,
'sb70c17f7899f9b01': `Ladina`,
'sb71941f552f3504d': `Määrake eriväärtus`,
'sb740eab4afd5a710': `Ruudu automaatne voog`,
'sb741b6e0ca589122': `Pöörake kiht tagasi`,
'sb7c77d0415de05cf': `Testide läbiviimine`,
'sb7fb7568f6883ab8': `Jaga aktiivset dokumenti`,
'sb85774dc5d18ff0f': `Kinnitage`,
'sb85b1e36579852a6': `Vale e-posti aadress või salasõna`,
'sb884fa76bfc55429': `Araabia keel`,
'sb8a3d4df7d1c5e6b': `Saldo`,
'sb8f610a0e8df91fc': `Heledus`,
'sb8f855b49234b81b': `Rakenda`,
'sb905da066c10182c': `Pluss tumedamad`,
'sb940ade1bd81be7e': `Vasakpoolsete all`,
'sb9e9a7dd45966756': `Märgi valik paksuks`,
'sba509fd8ed61d1d5': `Salvestamata fail`,
'sba64d8954d027206': `Läbipaistvus`,
'sba88d90cd6c751b3': `Veergreegel`,
'sbaf0a7c417e388af': `Tervis`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Taustafilter`,
'sbb85a407d730e13d': `Sisestage otsing`,
'sbb86c6c96f598bb8': `Segatud`,
'sbba0156f795d8c07': `Valiku muutmine`,
'sbba865d4b437944f': `Atribuut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Eemaldage`,
'sbc5f2a81604baf9b': `Rubriik 6`,
'sbc5f2b81604bb14e': `Rubriik 5`,
'sbc5f2c81604bb301': `Rubriik 4`,
'sbc5f2d81604bb4b4': `Rubriik 3`,
'sbc5f2e81604bb667': `Rubriik 2`,
'sbc6953a36ced943f': `privaatsuspoliitika`,
'sbd181cd54b8402a4': `Valiku muutmine`,
'sbd35ee879d9cf770': `Rubiini tekst`,
'sbd40f40cbadd38d5': `Eemaldage see vidinapakett`,
'sbd72dc858de95ce8': `Birma`,
'sbe3c60c65f129daa': `Humanitaarteadused`,
'sbe4a7c8f231739b3': `või kleebi/pane/valige fail`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Sisestage reavahetamine`,
'sbf00e1ee999ea94e': `Sisestage skript`,
'sbf519920c2017d67': `Riputades`,
'sbfa01f189a68d3e9': `Flex kasvada`,
'sbff54e740c4086eb': `Näita tundmatuid pakette`,
'sbfff51feacf30196': `Sanskriti`,
'sc0ceaa9843510f67': `Türkmenistani`,
'sc1611c0558728a2a': `Positsioon`,
'sc1a155cc25899250': `Tabeli rea rühm`,
'sc1aa1f6051b7102a': `Rumeenia`,
'sc1edebeaef92b7bd': `Fikseeritud tabeli paigutus`,
'sc1fff4f356dfb2fb': `Transform`,
'sc24bda3c061fddf8': `Klõpsatav ala`,
'sc252a4e091763606': `Tabeli alumise osa sisestamine`,
'sc2536e077514accc': `Kerimine`,
'sc275dd00036d16cb': `Tsitaadid iseloomu`,
'sc28864200d2a3799': `Kopeeri QR-kood pildina`,
'sc2a24a9dd41a9503': `Kaunistusliin`,
'sc2b734cca2fa643b': `Pan (alla)`,
'sc2e2a0dbf03723b7': `Edasijõudnud: Näita tundmatutest allikatest pärinevaid pakette paketihalduris (hoiatus: võib olla ohtlik)`,
'sc3998b77d72c2932': `Sisestage veebisait (inline frame'ina)`,
'sc3ac225273c8316b': `Üldine`,
'sc3cfee84dbbf36ae': `Kohalik fail`,
'sc3f09a9b6fa4fbed': `Sisemine`,
'sc43767deea72e9f3': `Kirjeldus Loetelu`,
'sc462bbdd36bcba6b': `Viitekast`,
'sc4ee3e4ee994dafd': `Ukraina`,
'sc50d09edf9325339': `Dialoog`,
'sc52b67794c06a0d3': `Perspektiivne päritolu (y)`,
'sc52e8b794c0913d6': `Perspektiivne päritolu (x)`,
'sc53de149fcaad713': `Tegelastevaheline`,
'sc546f489f9c0cced': `Lülitab aktiivse dokumendi testimisrežiimi ümber.`,
'sc5bcf50d1b578d9f': `Kirjatüübi funktsioonide seaded`,
'sc5cb39478b9b7625': `Märgista valik allmärkusena`,
'sc6415b50ff928294': `Nimekiri`,
'sc650ff15b20fe9d3': `Pöörake (z)`,
'sc6578b15b2154365': `Pöörake (x)`,
'sc65aff15b2183e58': `Pöörake (y)`,
'sc6da0f4a7e4d710e': `Kirjastiili keele ületamine`,
'sc74e3567875ce255': `Nii teie vidina silt kui ka NPM-paketi nimi`,
'sc7eb080b96e244df': `Malai`,
'sc8ac7ef92b95df3f': `Liikumine (x)`,
'sc8af536e2084ade0': `Palett`,
'sc8b022f92b992bc2': `Liikumine (y)`,
'sc8b39af92b9c2d81': `Liikumine (z)`,
'sc8d2c7f6c33a2b32': `Valitud elementide teksti stiili (joondus, taandamine, vahe jne) määramine.`,
'sc8fa0e3de389ef1c': `Kirjasuuruse reguleerimine`,
'sc9474bf7a0668d73': `Kokkuvõte`,
'sc94e314312a8900c': `Tšehhi`,
'sc980855a000b76ea': `Alumine`,
'sc98b103772de63f4': `Soome`,
'sca7cfe2bef51b2a5': `Juurde`,
'sca7fed2bef53cb99': `Rolli`,
'scabe6ecee5e01fd2': `Malta`,
'scace301a88231cce': `Embed`,
'scbc55f622ec078c1': `Vaata kasti`,
'scbe537fc38ff4c13': `Ruudustiku automaatsed veerud`,
'scc1db59d292cbc4c': `Jaotis`,
'scc56b218a2689c42': `Armeenia`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Padding Box`,
'scd9cedeb5ece3adb': `Silpkonnatähtedega`,
'scdf536b65be39ec5': ` Luua/importida`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideograafiline`,
'sceecdd0bb404bc17': `Lisage valikurühm`,
'scf00d48fd5953a03': `Kreeka`,
'scf932840a69dbb7c': `Portugali`,
'scf932a8577057752': `Footer`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `All paremal`,
'sd01178c54f648118': `Saldosambad`,
'sd03bff50f87f82d4': `Kirjavahemärk sidekriipsuga`,
'sd05a155fe09c2866': `Online, kui kasutate`,
'sd0864ea6cb6ef22e': `Ühendus`,
'sd10fdbe6caf9a998': `Rida katkestus`,
'sd121d3b959b7888d': `Kiiruse optimeerimine`,
'sd1a78e667a1a139f': `Märgista valik sisestuseks`,
'sd1cffad290ea5b3b': `Hoidke kõik`,
'sd1f10284eeb17b25': `Fidži`,
'sd1f44f1a8bc20e67': `E-post`,
'sd1f81984eeb7c0e8': `Täitke`,
'sd29dc07235eea0f5': `Tsitaat`,
'sd2addf69477cd4b4': `Impordipakett`,
'sd2ed26defc646d47': `Taustafilter`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fikseeritud`,
'sd3a288c1094b8a63': `Veeru reegli laius`,
'sd3c65ef5c380c046': `Sisemine`,
'sd3dcb76f7b28adb8': `Läti`,
'sd3eca1e0f4209f6e': `Trimmi kõik`,
'sd3f402df8619ddcd': `See teave teie kohta lisatakse automaatselt uutele dokumentidele. Seda saate muuta
          iga dokumendi puhul metaandmete redaktoris.`,
'sd4368b12645d3c0f': `Sisestage portaal`,
'sd452cebf4a0313d1': `Näita lähtekoodi redigeerimise käske`,
'sd48cc52117f4d68b': `Itaalia`,
'sd52660ee947ca58b': `Tabeli veeru sisestamine`,
'sd588d17a1b25c220': `Teksti ülevoolamine`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Kõrgemad haridusasutused.`,
'sd5cf95145e4d89ca': `Tee see lõik lahti`,
'sd5fd9d11a92f5b1d': `Alumine vasakpoolne (y)`,
'sd60c9bbc51375635': `Nupu sisestamine`,
'sd66c4767fa3dde28': `Aktsentne värv`,
'sd679c8b1bf8cc8a5': `Väikesed mütsid`,
'sd7086c4425c53c80': `Kirjatüüpkond`,
'sd837f42ac7cbfb58': `Kuju (väljastpoolt)`,
'sd88076d2994ee0fb': `Väljaarvamine`,
'sd89a2e529b31ef43': `Tagasi`,
'sd8a345e95668b73b': `Vertikaalne, paremalt vasakule`,
'sd8ce9e57270b030d': `Kirjatüübi venitamine`,
'sd8ecf227c7c49331': `Matemaatiline`,
'sd8f923198e0c5c6a': `End`,
'sd9c21e5f60d6bdd8': `Taani`,
'sd9ff8e2612e63d50': `Piirikasti suuruse määramine`,
'sda2d76b976502a8d': `Avatud...`,
'sda344aacb837387e': `Asukoht konteineris`,
'sda5b6fa8b771f996': `Ujumine vasakule`,
'sda9254d1f1228e1a': `Ungari`,
'sdb1595f5c742dfbb': `Sisend`,
'sdb711380a28fec75': `Sisesta nimekiri (tellitud)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `All paremal (y)`,
'sdc48456f9a27ae02': `Generaator`,
'sdc70d81cf6c28533': `Gruusia`,
'sdd1ff479d04ac140': `Avalik`,
'sdd2fc8919a9c3111': `Tausta segamisrežiim`,
'sdd35b688281b6dea': `Jaapani`,
'sddc49047f66a64ab': `Kirjeldus puudub`,
'sdef34fe08bb28b09': `Hiina keel (lihtsustatud)`,
'sdf62e305e1594805': `Märgi valik rubiinimärgistusega`,
'sdf946172dfa0328f': `Ülesseatud indeks`,
'sdf9bc5d9b7f3e3de': `Kohandamine`,
'se036b53f145441cd': `Segatud sisu`,
'se06f459fccdc3ce9': `Viimase tekstirea joondamine`,
'se0a782a8be8e018b': `Norra`,
'se0cda6b80a1bb50f': `Slovakkia`,
'se0f67eae944f8f94': `Mute`,
'se1312d6528f9a259': `Joruba`,
'se16c5e66886fbc59': `Artikkel`,
'se1f5bb0386c88f96': `Määrab valitud teksti värvi`,
'se219da7b1e955c65': `Selge vorming`,
'se25e4f2cb77b8be8': `WebWriter'i liidese ja uute dokumentide keeled`,
'se2796c5824ec8916': `Sisu nähtavus`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Kõikjal`,
'se39c065efa467782': `Baskimaa`,
'se3b4c857f91f80d7': `Klaviatuuri otseteed`,
'se47baf2fd16b9d2b': `Mall`,
'se48bd9e6c2a3109d': `Kontod`,
'se58467472725ad0c': `Pildi eraldusvõime`,
'se58f06c2b0583ff7': `Valige koordinaadid`,
'se5dc1e97fb743ade': `Vahemaa`,
'se619a501d1bfe6a5': `Wrap`,
'se62385ac082368d2': `Märgi valik tsitaadi allikaks`,
'se6297163cac9d276': `Muuda allikas`,
'se633223a0b88625e': `Raku paigutamine`,
'se638417c560cfe5c': `Break inside`,
'se64f418b4e733b6c': `Sisestage väljund`,
'se6cdad455e2d8c02': `Sisestage jagunemine`,
'se79c0a3ac70d8fb3': `Asp. suhe (x)`,
'se79fae3ac710dc36': `Asp. suhe (y)`,
'se7fad370d8fb4cec': `Optimeerida loetavust`,
'se8a94b4effa2033e': `Tähestik`,
'se95d4e55ea186d9a': `Kerimisriba värv`,
'se96d43a515b8451c': `Sloveenia`,
'se96fd76ba1b2975a': `Keskne`,
'se9ac05f36b004eb0': `Peida sissejuhatav ekskursioon. Lülita välja, nii et ekskursioon kuvatakse uuesti.`,
'se9b1fec72ffd8f48': `Kohalik`,
'sea24bdcaa2bd2dec': `Kohustuslik snap`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Lülitab ümber metaandmete redaktori`,
'sea896ed51ad33287': `Konkreetsed stiilid puuduvad`,
'seaaaeb09e3b4e78b': `Käskude redigeerimine`,
'seabae79729c4b2ad': `Vahetage e-post`,
'seaecc8267bad6234': `Keskkool`,
'seaf97719986faf4f': `Lõhe`,
'seb19675a580f0628': `Vältida veergu`,
'seb4e52ef5ec7a7dc': `Värvid/Efektid`,
'seb8982ae8c3cdcc5': `Indoneesia`,
'sebbced89e0db2894': `Esimene baastase`,
'sec02109a0dd2a6c8': `Rõhk värvi`,
'sec2557a35b702525': `Muutuv`,
'sec2da4aa7a02b925': `Islandi`,
'sec30fbb20f102670': `Sisesta kokkuvõte`,
'sec8b0b6c729816b6': `Pealkiri Rühm`,
'seccd05955adb76bc': `Plakat`,
'sed17285cd25d6389': `Kataloog, kus asub package.json`,
'sed318ec045c5144f': `Üle`,
'sed713f1b916fb469': `Piiride vahekaugus (x)`,
'sed74a31b9172942c': `Piiride vahekaugus (y)`,
'sed86bd0deb2e5372': `Teksti teisendamine`,
'see2fcaedf9743ec6': `Asukoht`,
'seec6798afe90ffc8': `Prindi`,
'sef00c258bc1ecf1e': `Sellel uuritaval on salvestamata muudatused.`,
'sef23dd271edd4a8b': `All vasakpoolne`,
'sef24caccbd4645ef': `Paindlik kokkutõmbumine`,
'sef49aec68fd1dc66': `Nimi`,
'sef73fe18e351eb35': `Märksõnad`,
'sef75f458d77491af': `Valikugrupp`,
'sefcf950b3cc4fc3b': `Keel`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Sisu`,
'sf0cab2483f66aa2e': `Kohandatud`,
'sf0e261e04eda82ff': `Välimus`,
'sf1045382c1fd9a85': `Täpsed trükivärvid`,
'sf14c35392ec7bf10': `See funktsioon ei ole Firefoxis saadaval. See on saadaval Chrome'is või Edge'is.`,
'sf14f9d5f9f6ca342': `Plus kergem`,
'sf1868dc19e3917bb': `Hispaania`,
'sf190149f9d8bbb2a': `Kirjutamise režiim`,
'sf1e79171c4856543': `Oled sa kindel? Seda toimingut ei saa tagasi pöörata, kõik teie seaded kustutatakse
          ja lähtestatakse.`,
'sf21c1f60c7515f44': `Märgista valik näidisväljundina`,
'sf21fb4f4b9e8911f': `Laius`,
'sf22a3737146ec910': `WebWriter saab SVG-dokumenti otse dokumenti sisse põimida.`,
'sf2514d5dc78b1654': `Sisesta vidin`,
'sf28903d4ca0ddcfc': `Eemaldage see konto`,
'sf2ab37af0abc55ef': `Peida sissejuhatav ekskursioon`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf2cbb5e519264e67': `Suuruse muutmine nii horisontaalselt kui ka vertikaalselt`,
'sf2d5cbc2fe0ad65a': `Kleepuv`,
'sf2d96d0eb32cb81f': `Animatsiooni kompositsioon`,
'sf2de3dbe2108637a': `Kujundamine`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Sisestage lugu`,
'sf3c4da68b08a2590': `Madagaskar`,
'sf471ec2496f904cc': `Muudatuste äraviskamine`,
'sf4849bc200e279ed': `Tabelipealkiri`,
'sf486ca1fdbe08645': `Sisestage joonis`,
'sf4b537d4cbd8f5fd': `Tekst üles`,
'sf4e0e02a5277ef23': `Tekstiala sisestamine`,
'sf4f067d41efd4b83': `Skaala (y)`,
'sf4f3cbd41f002b46': `Skaala (x)`,
'sf4fa67d41f05a008': `Skaala (z)`,
'sf5197db2d5f2926a': `Pöörake`,
'sf52d840949a980d1': str`
          ${0}
          kustutatakse lõplikult. Kas olete kindel? 
        `,
'sf55d634dcc743595': `Teenused`,
'sf59c9081d106dd9c': `Märgi valik muutujaks`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Dokumendi kustutamine`,
'sf65df67a03bebe4b': `Vajalik selle vidina jaoks`,
'sf6673729c03ae999': `Reset WebWriter`,
'sf67571992e7dc88e': `Täielik tähtaeg`,
'sf6b4934598f7ed10': `Lubab valiku tegemist`,
'sf6e1665c7022a1f8': `Parool`,
'sf79e0d78b56444f1': `Rivisuunaline ots`,
'sf7a5f7a7c80c3082': `Mõlemad`,
'sf7c0eba7c822e3d6': `Bold`,
'sf86bd4d2982f3b74': `Märgista valik koodina`,
'sf8e82313fa411494': `Märgi valik lingiks`,
'sf955eff73fb6b573': `Serbia`,
'sf9929e2d356260c5': `Korruta`,
'sf993bb199fefbe04': `Kõik`,
'sf9ecf969dd4b8164': `Mõlemad servad`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Privaatne juurdepääs`,
'sfa59c7777e2a0eeb': `Andmeloendi sisestamine`,
'sfaa0a67db5c11f72': `Esimene tekstirida sissepoole tõmmata`,
'sfb231a52211b133f': `Teksti ümberpööramine puudub`,
'sfb68cae41d749423': `Esialgne`,
'sfb9b6edb0ed378c9': `Tsitaadi allikas`,
'sfbbab09dbe553571': `Vektorjoonise (SVG) sisestamine`,
'sfc00292e778b67e2': `Arvesti`,
'sfc63e31ac7c956ed': `Valige`,
'sfc815c9078bba30a': `QR-koodi allalaadimine pildina`,
'sfcdd8e672c75b713': `Aadress`,
'sfcebd18506f1e535': `Flow`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Väljund`,
'sfdb1e4d90981a535': `Jagage seda dokumenti`,
'sfdeef3dccf409f81': `See märksõna on vajalik vidinate jaoks`,
'sfe6e758ad2603c1d': `Magistriõpe`,
'sfee1c12daf838935': `Värvipõletus`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Dialoogi sisestamine`,
'sffa395f64ec6ac36': `Bulgaaria`,
'sffdadf0a576fd802': `Kõrgus`,
'spaceKey': `Kosmos`,
'tabKey': `⭾ Tab`,
'upKey': `↑ üles`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  